import { TEMPLATE_COMPONENTS } from "./Templates";

export default function Preview({ resume, scale = 0.75 }) {
  const Tpl = TEMPLATE_COMPONENTS[resume.template] || TEMPLATE_COMPONENTS.centered;
  return (
    <div className="w-full overflow-auto bg-slate-100 p-6 rounded-xl">
      <div className="mx-auto" style={{ width: "fit-content" }}>
        {/* The actual exported element - keep at full size, then scale for view */}
        <div id="resume-export" className="bg-white paper-shadow rounded-md overflow-hidden" style={{ transform: `scale(${scale})`, transformOrigin: "top center" }}>
          <Tpl resume={resume} />
        </div>
      </div>
    </div>
  );
}
